import { render } from "./LoginPage.vue?vue&type=template&id=cf2011b2&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=cf2011b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cf2011b2"

export default script